import React from 'react';

const ProfileGold = props => {
  return (
    <svg
      className={props.className}
      width="30"
      height="32"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.662 19.723L3.085 23.863C1.8 24.564 1 25.911 1 27.375V31H29V27.375C29 25.911 28.2 24.564 26.915 23.863L19.332 19.727"
        stroke="#FABD18"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M15 21C10.582 21 7 17.418 7 13V9C7 4.582 10.582 1 15 1C19.418 1 23 4.582 23 9V13C23 17.418 19.418 21 15 21Z"
        stroke="#FABD18"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default ProfileGold;



// WEBPACK FOOTER //
// ./src/svg/ProfileGold.js